<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3 21V19H21V21H3ZM3 17V15H15V17H3ZM3 13V11H21V13H3ZM3 9V7H15V9H3ZM3 5V3H21V5H3Z" fill="currentColor"/>
    </svg>
    